import React, { Fragment, useState } from 'react'
import { Button, Select, Form, Spin, message } from 'antd'
import './Text.scss'
import { withTranslation } from 'react-i18next'
import TextEditor from './Text.ctrl'
import { api } from '../../../../services'
import { translationKeys } from '../../../../constants'

const { Option } = Select

const Test = (props) => {
  const {
    content, 
    closeEditor, 
    t, 
    isHideSaveButton, 
    handleInput,
    setTextContent
  } = props

  const [lang, setLang] = useState('')
  const [showValue, setShowValue] = useState('')
  const [isTranslating, setIsTranslating] = useState(false)

  const handleTranslation = async (targetLanguage) => {
    // Don't translate if no content or already translating
    if (!content || content.trim() === '' || isTranslating) {
      return
    }

    try {
      setIsTranslating(true)
      setLang(targetLanguage)
      
      // Strip HTML tags for translation API
      const plainText = content.replace(/<[^>]+>/g, '')
      
      // Detect source language
      const detectResponse = await api.audioSynthesizer.textTranslate({ text: plainText })
      
      if (detectResponse.data && !detectResponse.data.result) {
        throw new Error('Failed to detect source language')
      }
      
      const sourceLanguage = detectResponse.data.data
      
      // Translate content
      const translateResponse = await api.audioSynthesizer.textTranslate({
        text: plainText,
        source_language: sourceLanguage,
        language: targetLanguage
      })
      
      // Update content with translated text
      const translatedText = translateResponse.data.data
      setTextContent(translatedText)
      handleInput(translatedText)
      
      message.success(t('v4:translation_complete'))
    } catch (error) {
      console.error('Translation error:', error.message)
      message.error('Failed to translate text. Please try again!')
    } finally {
      setIsTranslating(false)
    }
  }

  const showText = (val) => {
    setShowValue(val)
  }

  return (
    <Fragment>
      <div className="text__controls">
        <Select
          showSearch
          style={{ width: '100%' }}
          placeholder={t('v4:translate_to')}
          optionFilterProp="children"
          onChange={handleTranslation}
          disabled={isTranslating || !content}
        >
          {translationKeys.map(item => (
            <Option key={item.code} value={item.code}>
              {item.name}
            </Option>
          ))}
        </Select>
      </div>
      
      <div className="el-editor">
        {showValue && (
          <Fragment>
            <div className="el-editor__component">
              <TextEditor value={content} />
            </div>
          </Fragment>
        )}
        <div className="el-editor__component" style={{ position: 'relative' }}>
          {showValue && (
            <h4 style={{ color: 'red' }}>
              * {t('v2:please_copy_desired_content')}
            </h4>
          )}
          
          <TextEditor 
            value={content || ''} 
            onChange={handleInput} 
          />
          
          {isTranslating && (
            <div 
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                zIndex: 100
              }}
            >
              <Spin 
                tip={'Translating...'} 
                size="large" 
              />
            </div>
          )}
        </div>
        {!isHideSaveButton && (
          <div className="el-editor__controls">
            <div className="el-editor__control">
              <Button
                type="default"
                size="small"
                icon="check"
                onClick={closeEditor}
                disabled={isTranslating}
              >
                {t('buttons:save')}
              </Button>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  )
}

const WrappedTest = Form.create({ name: 'text_form' })(Test)

export default withTranslation()(WrappedTest)